<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("heading.car_classifications") }}</v-toolbar-title>
      <v-spacer />
      <v-btn :to="{ name: 'create-carClassification' }" large class="primary">
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="car-classifications"
      resName="car_classifications"
      class="table-row"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-center">
          {{ item.max_persons_count }}
        </td>

        <td class="text-center">
          {{ item.min_persons_count }}
        </td>
        <td class="toggle-spacing text-center">
          {{ item.priority }}
        </td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="car-classifications"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>

        <td class="text-sm-center">
          <v-btn
            icon
            color="info"
            :to="`/car/classifications/edit/${item.slug}`"
          >
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon
              color="error"
              @click="handleDelete(item, index)"
              :title="$t('icon.delete')"
              small
              >mdi-delete</v-icon
            >
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </main>
</template>

<script>
export default {
  name: "CarClassification",
  data() {
    return {
      overlay: false,
      imagePath: "",
      dummyIcon: "https://via.placeholder.com/50x50?text=icon",

      headers: [
        "name",
        "max_persons_count",
        "min_persons_count",
        "priority",
        "visible",
        "actions"
      ]
    };
  },
  methods: {
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    }
  }
};
</script>
